import React, { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const ReelsOnboardingHint = () => {
  const [visible, setVisible] = useState(false);
  const [mounted, setMounted] = useState(false);
  const location = useLocation();
  const hideTimeoutRef = useRef(null);
  const lastMouseMoveRef = useRef(0);

  useEffect(() => {
    // Only show on home page
    if (location.pathname !== '/') {
      setVisible(false);
      return;
    }

    setMounted(true);

    // Show hint when cursor moves
    const handleMouseMove = () => {
      const now = Date.now();
      // Throttle: only show if 2+ seconds since last move
      if (now - lastMouseMoveRef.current > 2000) {
        lastMouseMoveRef.current = now;
        setVisible(true);
        
        // Clear any existing hide timeout
        if (hideTimeoutRef.current) {
          clearTimeout(hideTimeoutRef.current);
        }
        
        // Hide after 10 seconds
        hideTimeoutRef.current = setTimeout(() => {
          setVisible(false);
        }, 10000);
      }
    };

    // Add mouse move listener
    window.addEventListener('mousemove', handleMouseMove);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      if (hideTimeoutRef.current) {
        clearTimeout(hideTimeoutRef.current);
      }
    };
  }, [location.pathname]);

  // Hide hint when user clicks reels button
  const handleReelsClick = () => {
    setVisible(false);
  };

  if (!mounted || !visible) return null;

  return (
    <div
      className="fixed z-[60] transition-all duration-500 ease-out"
      style={{
        bottom: '156px',
        right: '24px',
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateY(0)' : 'translateY(10px)',
      }}
    >
      <div
        className="px-4 py-2 rounded-full backdrop-blur-md"
        style={{
          backgroundColor: 'rgba(0, 0, 0, 0.9)',
          border: '1px solid #FFCC32',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.4)',
        }}
      >
        <div className="text-center">
          <div className="text-white text-xs font-bold tracking-wider" style={{ fontSize: '11px' }}>
            WATCH • SHOP • RIDE
          </div>
          <div className="text-[#FFCC32] text-[10px] font-medium tracking-wide mt-0.5">
            See our products in action
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReelsOnboardingHint;